<template>
  <figure v-if="image" :class="figureClass">
    <RokkaImage
      v-bind="image"
      :hash="image?.file?.rokka?.hash ?? ''"
      :config="imageStyle"
      class="overflow-hidden w-full"
      :img-class="imgClass"
      :loading="loading"
      :preload="preload"
      :source-width="image?.file?.rokka?.sourceWidth"
      :source-height="image?.file?.rokka?.sourceHeight"
    />
    <Caption
      v-if="!hideCaption"
      :caption="caption"
      :copyright="copyright"
      class="mx-auto max-w-screen-xl"
      :class="captionClass"
    />
  </figure>
</template>

<script lang="ts" setup>
import type { DefineImageStyleConfig } from '#rokka/types'
import type { MediaImageFragment } from '#graphql-operations'
import { RokkaImage } from '#components'

defineOptions({
  name: 'MediaImage',
})

withDefaults(
  defineProps<{
    name?: string
    mid?: number
    caption?: MediaImageFragment['caption']
    copyright?: MediaImageFragment['copyright']
    image?: MediaImageFragment['image']
    imageStyle?: DefineImageStyleConfig | string
    imgClass?: string
    hideCaption?: boolean
    preload?: boolean
    loading?: 'lazy' | 'eager'
    captionClass?: string | string[] | Record<string, boolean>
    figureClass?: string | string[] | Record<string, boolean>
  }>(),
  {
    name: undefined,
    mid: 0,
    caption: '',
    copyright: '',
    image: undefined,
    imageStyle: () => {
      return 'wide'
    },
    imgClass: '',
    hideCaption: false,
    preload: false,
    loading: 'lazy',
    captionClass: 'mt-3',
    figureClass: '',
  },
)
</script>
